import { Flex, Icon } from '@chakra-ui/react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { memo } from 'react';

import { UpdateNotificationProps } from './types';

const UpdateNotification = memo(
  ({ updatedItemsCount, updatedItemsString }: UpdateNotificationProps) => {
    if (updatedItemsCount <= 0 || !updatedItemsString) {
      return null;
    }

    return (
      <Flex justifyContent="flex-end">
        <Flex
          w={{ base: '510px', md: '400px', xl: '460px' }}
          fontSize={{ base: 'xs', md: 'sm', xl: 'md' }}
          bgColor="#FEF3C7"
          p="3"
          color="#52525B"
        >
          <Icon
            as={InfoOutlinedIcon}
            fontSize={{ base: 'sm', xl: 'md' }}
            mt={{ base: '2px', md: '3px' }}
            mr="2"
            color="#E28800"
          />
          {updatedItemsString}
        </Flex>
      </Flex>
    );
  }
);

UpdateNotification.displayName = 'UpdateNotification';

export { UpdateNotification };
